import { render, staticRenderFns } from "./accordionPaySetTables.vue?vue&type=template&id=65d4b226&scoped=true"
import script from "./accordionPaySetTables.vue?vue&type=script&lang=js"
export * from "./accordionPaySetTables.vue?vue&type=script&lang=js"
import style0 from "./accordionPaySetTables.vue?vue&type=style&index=0&id=65d4b226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d4b226",
  null
  
)

export default component.exports